var render = function render(){var _vm=this,_c=_vm._self._c;return _c('date-picker',{ref:"datepicker",attrs:{"type":"date","format":"DD.MM.YYYY","range":""},model:{value:(_vm.datetime),callback:function ($$v) {_vm.datetime=$$v},expression:"datetime"}})
}
var staticRenderFns = []

export { render, staticRenderFns }